export const MAX_INTEGER = 0x7ffffff0;
export const PHONE_PATTERN = "^\\+(?:[0-9] ?){6,14}[0-9]$";
export const CZECH_PHONE_CODE_PREFIX = "^\\+420";
export const CZECH_PHONE_PATTERN = "^\\+420(\\d{9}$)";



// WEBPACK FOOTER //
// ./src/core/common/utils/constant.ts